import { createReducer, on } from '@ngrx/store';

import { TeamListStateActions } from './team-list-state.actions';
import { teamListInitialState, teamListStateAdapter, TeamListStateModel } from './team-list-state.model';

export const teamListStateReducer = createReducer(
  teamListInitialState,
  on(TeamListStateActions.fetchSuccess, (state, { teams }): TeamListStateModel => ({
    ...teamListStateAdapter.setAll(teams ?? [], state),
    fetchingTeams: false,
    isLoaded: true,
  })),
  on(TeamListStateActions.fetchError, (state): TeamListStateModel => ({
    ...state,
    fetchingTeams: false,
    isLoaded: true,
  })),
  on(TeamListStateActions.getSelectedTeam, (state, { id }): TeamListStateModel => ({
    ...state,
    // This is a temporary population of the selected team object while the API is fetching the full team object
    filterBarTeam: state.entities[id] || null,
  })),
  on(TeamListStateActions.getSelectedTeamSuccess, (state, { team }): TeamListStateModel => ({
    ...state,
    filterBarTeam: team,
  })),

  on(TeamListStateActions.addOne, (state, { team }): TeamListStateModel => teamListStateAdapter.addOne(team, state)),
  on(TeamListStateActions.removeOne, (state, { teamId }): TeamListStateModel =>
    teamListStateAdapter.removeOne(teamId, state)
  ),
  on(TeamListStateActions.updateOneSuccess, (state, { id, update }): TeamListStateModel => {
    const newState = {
      ...state,
    };

    if (state.filterBarTeam?._id === id) {
      newState.filterBarTeam = { ...newState.filterBarTeam, ...update };
    }

    return teamListStateAdapter.updateOne({ id, changes: update }, newState);
  }),
  on(TeamListStateActions.updateSelectedTeamInMemory, (state, { teamId, changes }): TeamListStateModel => {
    if (state.filterBarTeam?._id !== teamId) return state;
    return {
      ...state,
      filterBarTeam: { ...state.filterBarTeam, ...changes },
    };
  }),
  on(TeamListStateActions.updateSelectedTeamSettingInMemory, (state, { teamId, changes }): TeamListStateModel => {
    if (state.filterBarTeam?._id !== teamId) return state;
    return {
      ...state,
      filterBarTeam: {
        ...state.filterBarTeam,
        settings: { ...state.filterBarTeam.settings, ...changes },
      },
    };
  })
);
